<a
    *ngFor="let object of objects"
    [href]="getObjectLink(object.projectKey, object.type, object.id)"
    [matTooltip]="object.displayName" isEllipsisActive
    matTooltipPosition="left"
>
    {{object.displayName}}
</a>
